var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.video.isPsct
        ? _c("PscManager", {
            ref: "eventHandler",
            attrs: {
              video: _vm.video,
              player: _vm.player,
              "strict-sandbox": _vm.sensicTracker.strictMode,
              "sandbox-url": _vm.sensicTracker.sandboxUrl
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }